export default "__VITE_PUBLIC_ASSET__3dc0616f__"